import {
  ACTIVATING_GOOGLE_ANALYTICS_4_REQUEST,
  ACTIVATING_GOOGLE_ANALYTICS_4_SUCCEDDED,
  ACTIVATING_GOOGLE_ANALYTICS_4_FAILED,
  UPDATING_GOOGLE_ANALYTICS_4_REQUEST,
  UPDATING_GOOGLE_ANALYTICS_4_SUCCEDDED,
  UPDATING_GOOGLE_ANALYTICS_4_FAILED,
} from "../actionTypes.jsx";
import {
  activatingIntegrationSuccedded
} from "../integrations";
import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const GOOGLE_ANALYTICS_4_BASE_URL = `${apiUrl}/api/2.0/integrations/google-analytics-4`;

export function activateAccount(configuration) {
  return function (dispatch) {
    dispatch(activatingAccount());

    return axios({
      method: "POST",
      url: GOOGLE_ANALYTICS_4_BASE_URL,
      data: configuration,
    })
      .then((response) => {
        dispatch(activatingAccountSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
        return response.data;
      })
      .catch((error) => dispatch(activatingAccountFailed(error.errors)));
  };
}

function activatingAccount() {
  return {
    type: ACTIVATING_GOOGLE_ANALYTICS_4_REQUEST,
    payload: {},
  };
}

function activatingAccountSuccedded(json) {
  return {
    type: ACTIVATING_GOOGLE_ANALYTICS_4_SUCCEDDED,
    payload: json,
  };
}

function activatingAccountFailed(error) {
  return {
    type: ACTIVATING_GOOGLE_ANALYTICS_4_FAILED,
    payload: error,
  };
}

/**
 * Update google analytics 4 configuration
 */
export function updateGoogleAnalytics4Configuration(configuration) {
  return function (dispatch) {
    dispatch(updatingGoogleAnalytics4Configuration());

    return axios({
      method: "PUT",
      url: GOOGLE_ANALYTICS_4_BASE_URL,
      data: configuration,
    })
      .then((response) => {
        dispatch(updatingGoogleAnalytics4ConfigurationSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
        return response.data;
      })
      .catch((error) =>
        dispatch(updatingGoogleAnalytics4ConfigurationFailed(error.errors))
      );
  };
}

function updatingGoogleAnalytics4Configuration() {
  return {
    type: UPDATING_GOOGLE_ANALYTICS_4_REQUEST,
    payload: {},
  };
}

function updatingGoogleAnalytics4ConfigurationSuccedded(json) {
  return {
    type: UPDATING_GOOGLE_ANALYTICS_4_SUCCEDDED,
    payload: json,
  };
}

function updatingGoogleAnalytics4ConfigurationFailed(error) {
  return {
    type: UPDATING_GOOGLE_ANALYTICS_4_FAILED,
    payload: error,
  };
}
